import $ from "jquery";
import StickySidebar from "sticky-sidebar/dist/sticky-sidebar";

export default function elmSticky(elem) {
    function initSticky() {
        let heightHeader = $(".menu").outerHeight();

        if ($(".breadcrumbs").length) {
            heightHeader = heightHeader + $(".breadcrumbs").outerHeight();
        }

        window.stickySidebar = new StickySidebar(elem, {
            topSpacing: heightHeader + 50,
            bottomSpacing: 0,
            containerSelector: ".sticky-sidebar__container",
            innerWrapperSelector: ".sticky-sidebar__inner",
            resizeSensor: false,
        });

        $(elem + " img").each((i, img) => {
            img.addEventListener("load", function () {
                window.stickySidebar.updateSticky();
            });
        });
    }

    window.addEventListener("resize", () => {
        if (window.stickySidebar) {
            window.stickySidebar.destroy();
            window.stickySidebar = undefined;
        }
        if (window.matchMedia("(min-width: 768px)").matches) {
            initSticky();
        }
    });

    if (window.matchMedia("(min-width: 768px)").matches) {
        initSticky();

        setTimeout(function () {
            if (window.stickySidebar) {
                window.stickySidebar.destroy();
                window.stickySidebar = undefined;
            }
            initSticky();
        }, 2600);
    }
}
